/**
 * The item-link relationship types (JIRA-style). `key` is stored/sent to the backend; `outward` is
 * the phrasing when the current item is the SOURCE, `inward` when it is the TARGET. Symmetric types
 * read the same both ways. `group` is the heading shown in the drawer's Links section for a given
 * direction. Single source of truth for the drawer + the add-link type picker.
 */
export interface LinkTypeMeta {
  key: string;
  outward: string;
  inward: string;
  symmetric?: boolean;
}

export const LINK_TYPES: LinkTypeMeta[] = [
  { key: 'relates_to', outward: 'relates to', inward: 'relates to', symmetric: true },
  { key: 'blocks', outward: 'blocks', inward: 'is blocked by' },
  { key: 'depends_on', outward: 'depends on', inward: 'is required by' },
  { key: 'duplicates', outward: 'duplicates', inward: 'is duplicated by' },
  { key: 'causes', outward: 'causes', inward: 'is caused by' },
];

const BY_KEY = new Map(LINK_TYPES.map((t) => [t.key, t]));

/** The phrasing for a link type in a given direction (falls back gracefully for unknown types). */
export const linkPhrase = (type: string, direction: 'outward' | 'inward'): string => {
  const m = BY_KEY.get(type);
  if (!m) return type.replace(/_/g, ' ');
  return direction === 'outward' ? m.outward : m.inward;
};
